module.exports = __webpack_public_path__ + "static/media/help.c3c3da85.svg";